import {Actions} from "./actions";
import {ILoanProducts, ICompletedCategory, IKycModes} from "loan-application/interface";
import {getRequiredFieldsKey} from "loan-application/utils";

export interface IState {
    loanProducts: ILoanProducts[];
    applicationFields: any;
    selectedLoanProduct: string;
    requiredFieldsKey: string[];
    completedCategory: ICompletedCategory[];
    applicationIndex: number;
    kycModes: IKycModes[];
}

const defaultState: IState = {
    loanProducts: [],
    applicationFields: null,
    selectedLoanProduct: null,
    requiredFieldsKey: [],
    completedCategory: [],
    applicationIndex: null,
    kycModes: [],
};

export default function loanApplication(state = defaultState, action) {

    switch (action.type) {
        case `${Actions.SET_LOAN_PRODUCTS}`:
            return {
                ...state,
                loanProducts: action.body.product_specs,
            };
        case `${Actions.SET_APPLICATION_FIELDS}`:
            return {
                ...state,
                applicationFields: action.body,
                requiredFieldsKey: getRequiredFieldsKey(action.body.required_fields),
            };
        case `${Actions.CLEAR_APPLICATION_FIELDS}` :
            return {
                ...state,
                applicationFields: null,
            };
        case `${Actions.SELECTED_LOAN_PRODUCT}`:
            return {
                ...state,
                selectedLoanProduct: action.body,
            };
        case `${Actions.INITIALIZE_CATEGORY}`:
            return {
                ...state,
                completedCategory: action.body,
            };
        case `${Actions.CATEGORY_COMPLETED}`:
            return {
                ...state,
                completedCategory: state.completedCategory.map((category, i) => i === action.index ? { ...category, isCategoryCompleted: action.categoryStatus }
                    : category),
            };
        case `${Actions.SET_APPLICATION_INDEX}`:
            return {
                ...state,
                applicationIndex: action.body,
            };
        case `${Actions.SET_KYC_MODES}`:
            return {
                ...state,
                kycModes: action.body,
            };
        case Actions.UPDATE_APPLICATION_FIELDS:
            return {
                ...state,
                applicationFields: {
                    ...state.applicationFields,
                    required_Fields:{
                        ...state.applicationFields.required_Fields,
                        [action.body.index]: action.body.fieldsValue,                    
                    }
                }
            };
        default:
            return state;
    }
}
